export default __webpack_public_path__ + "static/media/publishOX_logo_mobile.82b8895e.png";